import { Directive, HostListener, Renderer, ElementRef } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { NgControl } from '@angular/forms';
@Directive({
  selector: '[appCamelCase]',
  providers: [TitleCasePipe]
})
export class CamelCaseDirective {

  constructor(
    private renderer: Renderer,
    private el: ElementRef,
    private titlecasePipe: TitleCasePipe,
    public model: NgControl
  ) { }

  @HostListener('keyup') onKeyUp() {
    this.el.nativeElement.value = this.titlecasePipe.transform(this.el.nativeElement.value);
    this.model.control.setValue(this.titlecasePipe.transform(this.el.nativeElement.value), { emitEvent: false });
    //

    //

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/dba-form-control/camel-case.directive.ts